import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams, GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { KtLogsListingModel, KTGridPostParams } from 'common/models/page-models/kt-logs/kt-logs-grid.model';
import { KtLogsModel } from 'common/models/page-models/kt-logs/kt-logs-model';


@Injectable({
    providedIn: 'root'
})
export class KtLogsGridDataService extends GridDataService<KtLogsListingModel, KtLogsModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.getKtLogs, http, ss);
    }

    createInstance(): KtLogsListingModel {
        return new KtLogsListingModel();
    }

    override getDeleteUrl(): string {
        return '';
    }

    override getGridParams(param): GridPostParams {
        return new KTGridPostParams();
    }

    override transformDataModel(data: any, param) {
        super.transformDataModel(data, param);
        // console.log(data)
        data.details.forEach(element => {
            element.createdDate = new Date(element.created).toLocaleDateString();
            element.createdTime = new Date(element.created).toLocaleTimeString();
            element.created = element.createdDate + ' ' + element.createdTime;
            element.ktstatusflag = element.ktstatusflag === 1 ? 'Yes' : 'No';

        });
        return data;
    }
}
